export class DeliveryMethod {
  Id: number = 0;
  Name: string;
  IsDeliveryAddressRequired: boolean;
  IsDefault: boolean;
}
